import * as React from 'react';
import {
  Logging,
  API,
  ResponseError,
  NotificationData,
  Seller,
  getUuidV4,
} from '@vcd-ecm-ui/Common';
import { useDispatch } from 'react-redux';

const useSeller = (
  gatewayEndPoint: string,
  sellerUuid: string,
): [Seller, NotificationData] => {
  const [seller, setSeller] = React.useState(null);
  const [sellerNotification, setSellerNotification] = React.useState(null);
  const dispatch = useDispatch();

  const getSeller = () => async (): Promise<void> => {
    try {
      const api = new API(gatewayEndPoint);

      const sellerApi: Seller = await api.ecwizard.getSellerV41(sellerUuid);

      Logging.Info('Seller:', sellerApi);

      setSeller(sellerApi);
    } catch (error) {
      const notification: NotificationData = {
        type: 'Error',
        title: 'Seller Read Error',
        description: 'Unable to read Seller',
        error: error as ResponseError,
      };
      setSellerNotification(notification);
    }
  };

  React.useEffect(() => {
    // Clear the Seller if the Uuid does not match the loaded Seller
    if (seller && (seller.uuid !== sellerUuid)) {
      setSeller(null);
    }

    dispatch(getSeller());
  }, [sellerUuid]);

  return [seller, sellerNotification];
};

export default useSeller;
